import React, { useCallback, useMemo, useContext } from "react";
import { Excalidraw, THEME } from "@excalidraw/excalidraw";
import { restore } from "@excalidraw/excalidraw";
import { ThemeContext } from "../ThemeContext";

const LOCAL_STORAGE_KEY = "excalidraw-scene";

const ExcalidrawPage = () => {
  const { theme } = useContext(ThemeContext);

  // Prepare initialData for Excalidraw
  const initialData = useMemo(() => {
    const saved = localStorage.getItem(LOCAL_STORAGE_KEY);
    if (saved) {
      try {
        const { elements, appState, files } = JSON.parse(saved);
        return restore({ elements, appState, files });
      } catch (e) {
        // Ignore parse errors
      }
    }
    return undefined;
  }, []);

  // Save scene to localStorage on change
  const handleChange = useCallback(
    (elements, appState, files) => {
      localStorage.setItem(
        LOCAL_STORAGE_KEY,
        JSON.stringify({
          elements,
          appState: {
            ...appState,
            // Don't persist ephemeral state
            collaborators: undefined,
          },
          files,
        })
      );
    },
    []
  );

  // Map app theme to Excalidraw's THEME
  const excalidrawTheme = theme === "dark" ? THEME.DARK : THEME.LIGHT;

  return (
    <div style={{ height: "100vh", width: "100vw" }}>
      <Excalidraw initialData={initialData} onChange={handleChange} theme={excalidrawTheme} />
    </div>
  );
};

export default ExcalidrawPage;
